// Client-side version of VoiceoverApi.getAudioDuration. needed because we can't
// pass a File object to a server action (i.e. VoiceoverApi.calculateCost)
export async function calculateAudioDuration(file: File): Promise<number> {
    const { parseBuffer } = await import('music-metadata');

    const arrayBuffer = await file.arrayBuffer();
    const buffer = Buffer.from(arrayBuffer);

    const metadata = await parseBuffer(buffer, { mimeType: file.type });
    return metadata.format.duration // duration in seconds
        ? Math.ceil(metadata.format.duration)
        : 0;
}
